class AnnouncementBar extends HTMLElement {
  #current = 0;
  #interval = undefined;
  #slides = [];

  connectedCallback() {
    // Warte auf DOM-Rendering
    requestAnimationFrame(() => {
      this.#slides = Array.from(this.querySelectorAll('[ref="slides[]"]'));

      if (this.#slides.length <= 1) return;

      // Initialisierung: nur erste Slide sichtbar
      this.#slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i !== 0 ? 'true' : 'false');
      });

      this.addEventListener('mouseenter', () => this.#suspend());
      this.addEventListener('mouseleave', () => this.#resume());
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.#suspend() : this.#resume();
      });

      // Pfeile
      const prev = this.querySelector('[data-action="previous"], .slideshow-control--previous');
      const next = this.querySelector('[data-action="next"], .slideshow-control--next');
      prev?.addEventListener('click', () => this.#go(this.#current - 1));
      next?.addEventListener('click', () => this.#go(this.#current + 1));

      this.#startAutoplay();
    });
  }

  #go(index) {
    const len = this.#slides.length;
    this.#current = ((index % len) + len) % len;
    this.#slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i !== this.#current ? 'true' : 'false');
    });
  }

  #startAutoplay() {
    const attr = this.getAttribute('autoplay');
    const seconds = parseInt(attr, 10);
    if (isNaN(seconds) || seconds <= 0) return;

    this.#interval = setInterval(() => {
      if (this.matches(':hover') || document.hidden) return;
      this.#go(this.#current + 1);
    }, seconds * 1000);
  }

  #suspend() {
    clearInterval(this.#interval);
    this.#interval = undefined;
  }

  #resume() {
    this.#suspend();
    this.#startAutoplay();
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
